import { playShutUp, addPlayerLifecycle } from "./playback";

let playing = false

export const handleMicSuccess = (player) => {
  addPlayerLifecycle(player, () => playing = false)
  return (stream) => {
    _handleMicSuccess(stream, player)
  }
}

const _handleMicSuccess = function (stream, player) {
  const context = new AudioContext();
  const source = context.createMediaStreamSource(stream);
  const processor = context.createScriptProcessor(1024, 1, 1);

  source.connect(processor);
  processor.connect(context.destination);
  console.log(player)
  processor.onaudioprocess = function (e) {
    // Do something with the data, e.g. convert it to WAV
    const floatArr = e.inputBuffer.getChannelData(0); // todo different channel for diff device
    const arr = Array.prototype.slice.call(floatArr);
    const maxMic = Math.max(...arr)
    const threshold = localStorage.getItem('threshold') || 80
    if (maxMic > threshold / 100 && !playing) {
      playing = true
      playShutUp(player)
    }
  };
};
